module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro10yearslater-1@3x.ver2_0_2.jpg?e1b2b5c4";